"use client";

import { Auth } from "@/types/ApiResponses/Auth";
import { createContext, useContext } from "react";

const StaticAuthContext = createContext<Auth | null>(null);

interface Props {
  auth: Auth;
  children: React.ReactNode;
}

export const StaticAuthProvider: React.FC<Props> = ({ auth, children }) => {
  return (
    <StaticAuthContext.Provider value={auth}>
      {children}
    </StaticAuthContext.Provider>
  );
};

export const useStaticAuth = (): Auth => {
  const context = useContext(StaticAuthContext);
  if (!context) {
    throw new Error("useStaticAuth must be used within StaticAuthProvider");
  }
  return context;
};
